// ../../react-shim.js
import React from "react";

// src/focus-lock.tsx
import {
  focus,
  getAllFocusable,
  __DEV__
} from "@nature-ui/utils";
import React2 from "react";
import ReactFocusLock from "react-focus-lock";
import { jsx } from "react/jsx-runtime";
var FocusLock = (props) => {
  const {
    initialFocusRef,
    finalFocusRef,
    contentRef,
    restoreFocus,
    children,
    isDisabled,
    autoFocus,
    persistentFocus,
    lockFocusAcrossFrames
  } = props;
  const onActivation = React2.useCallback(() => {
    if (initialFocusRef == null ? void 0 : initialFocusRef.current) {
      initialFocusRef.current.focus();
    } else if (contentRef == null ? void 0 : contentRef.current) {
      const focusable = getAllFocusable(contentRef.current);
      if (focusable.length === 0) {
        focus(contentRef.current, { nextTick: true });
      }
    }
  }, [initialFocusRef, contentRef]);
  const onDeactivation = React2.useCallback(() => {
    var _a;
    (_a = finalFocusRef == null ? void 0 : finalFocusRef.current) == null ? void 0 : _a.focus();
  }, [finalFocusRef]);
  const returnFocus = restoreFocus && !finalFocusRef;
  return /* @__PURE__ */ jsx(ReactFocusLock, {
    crossFrame: lockFocusAcrossFrames,
    persistentFocus,
    autoFocus,
    disabled: isDisabled,
    onActivation,
    onDeactivation,
    returnFocus,
    children
  });
};
if (__DEV__) {
  FocusLock.displayName = "FocusLock";
}
export {
  FocusLock
};
